"use client";
import React, { Fragment } from "react";
import Script from "next/script";
import { ChakraProvider } from "@chakra-ui/react";
import { HubspotProvider } from "next-hubspot";
import MainLayout from "@/layouts/mainLayout";
import { theme } from "@/theme/index";
import "styles/app.scss";

export function Providers({
  children,
  nonce,
}: {
  children: React.ReactNode;
  nonce?: string;
}) {
  return (
    <Fragment>
      {process.env.VERCEL_ENV === "production" && (
        <>
          <Script id="cookie-consent" nonce={nonce} type="text/javascript">
            {`
          var _iub = _iub || [];
          _iub.csConfiguration = {
            "enableCcpa":true,
            "countryDetection":true,
            "whitelabel":false,
            "lang":"en",
            "siteId":2680756,
            "cookiePolicyId":57406618,
            "enableTcf":true,
            floatingPreferencesButtonDisplay:"anchored-center-right",
              "banner":{
              "acceptButtonDisplay":true,
              "customizeButtonDisplay":true,
              "position":"float-bottom-left",
              "zIndex":99999998
            }
          };
        `}
          </Script>
          <Script
            nonce={nonce}
            src="//cdn.iubenda.com/cs/tcf/stub-v2.js"
            type="text/javascript"
          ></Script>
          <Script
            nonce={nonce}
            src="//cdn.iubenda.com/cs/tcf/safe-tcf-v2.js"
            type="text/javascript"
          ></Script>
          <Script
            nonce={nonce}
            src="//cdn.iubenda.com/cs/ccpa/stub.js"
            type="text/javascript"
          ></Script>
          <Script
            async
            nonce={nonce}
            src="//cdn.iubenda.com/cs/iubenda_cs.js"
            type="text/javascript"
          ></Script>
        </>
      )}
      <ChakraProvider
        theme={theme}
        toastOptions={{
          defaultOptions: {
            duration: 6000,
            isClosable: true,
            position: "bottom-right",
          },
        }}
      >
        <HubspotProvider>
          <MainLayout>{children}</MainLayout>
        </HubspotProvider>
      </ChakraProvider>
    </Fragment>
  );
}
